

import React, { useState, useEffect } from "react"
import { Form, Button, Card,   Row, Col } from "react-bootstrap"
import { useNavigate } from "react-router-dom"


export default function Config() {

    const [config, setConfig] = useState({qrId: "", appToken: "", restApi: ""})
    const navigate = useNavigate()

    const onChangeValue = (e) => {
        const { name, value } = e.target
        setConfig((prevState) => ({
            ...prevState,
            [name]: value
        }))
    }


    const handleSave = async (e) => {
        e.preventDefault()
        localStorage.setItem("appKeyConfig", JSON.stringify(config))
        alert("Configuration saved!")

        console.log("Saved config ", config)
    }

     const handleClose = async (e) => {
        e.preventDefault()
        navigate("/")
    }

    useEffect(() => {
        const savedConfig = localStorage.getItem("appKeyConfig")
        if (savedConfig) {
            setConfig(JSON.parse(savedConfig))
        }
    }, [])


    return (
    <>
        <Card className="text-center">
        <Card.Body>

            <div className="w-100 text-center mt-2 mb-4">
                <h6 className="mt-20 gray-light">Set up your application QR Configuration</h6>
            </div> 
            <Form>
            <Form.Group as={Row} className="mb-3" id="qrId">
                <Form.Label column sm={3} className="gray-text">QR ID</Form.Label>
                <Col sm={9}>
                <Form.Control type="text" value={config.qrId} name="qrId" required className="small-text" onChange={onChangeValue} />
                </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" id="appToken">
                <Form.Label column sm={3} className="gray-text">App Token</Form.Label>
                <Col sm={9}>
                    <Form.Control as="textarea" rows={3} value={config.appToken} name="appToken" required className="small-text" onChange={onChangeValue} />
                </Col>
            </Form.Group> 
                
            <Form.Group as={Row} className="mb-3" id="restApi">
                <Form.Label column sm={3} className="gray-text">REST API URL</Form.Label>
                <Col sm={9}>
                    <Form.Control type="text" value={config.restApi} name="restApi" required className="small-text" onChange={onChangeValue} />
                </Col>
            </Form.Group>

            <Button variant="primary"  className="w-100  button-radius mb-3" onClick={handleSave}>
                Save
            </Button>

            <Button variant="danger" className="w-100  button-radius" onClick={handleClose}>
                Close
            </Button>

            </Form>
        </Card.Body>
        </Card>
    
    </>
    )
     
    

}